import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/usePrice";
import PriceAddForm, {formSchema} from "./PriceAddForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const PriceAddFormProvider = ({ initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const initialData = initialFormState()

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialData
    });
    const { insertPrice, } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (initialData) {
            reset(initialData);
        }
    }, [initialData, reset]);

    
    const onSubmitHandler: SubmitHandler<FormInput> = async (values) => {
        const data = await insertPrice(values, redirectPath)
        if (data && successAction) {
            successAction(data)
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={
                        (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSubmit(onSubmitHandler)(e)
                        }
                    }
                    noValidate
                >

                    <PriceAddForm watch={watch}/>

                    <Stack direction="row" spacing={1} sx={{ justifyContent: "end", padding: 5 }}>

                        { cancelButton }

                        
                        <Badge badgeContent={Object.values(errors).length} color="error" anchorOrigin={ {vertical: 'bottom'} }>
                            <Button size="medium" variant="contained" color="primary" type='submit' startIcon={<Save />}>
                                <Trans>Add</Trans>
                            </Button>
                        </Badge>

                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default PriceAddFormProvider;
